import { useContext } from 'react';
import { AccountRequestContext } from '@frontend/components/pages/accountRequests/AccountRequestContextProvider';

export function useAccountRequestContext() {
    return useContext(AccountRequestContext);
}
